(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker-presupuesto"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pnl-presupuesto-link]');

    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));

    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
